import { styled } from 'solid-styled-components';
import theme from '../../style/theme';

export const Styled404Wrapper = styled.div<{ adjustForHcpHeader: boolean }>`
    ${p => p.adjustForHcpHeader ? `
        ${theme.mediaQueries.desktopMin} {
            margin-top: 8rem;
        }
            
        margin-top: 6rem;
    ` : ''}
`;

export const Styled404 = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    margin: 5rem;
`;